<script>
export default {
    name: 'TermsOfService',
    computed: {
        tos() {
            return this.$appConfig('TOS', false)
        },
        privacyPolicy() {
            return this.$appConfig('PRIVACY_POLICY', false)
        },
    },
    methods: {},
}
</script>

<template>
    <div>
        <div>
            <h1><strong>Nutzungsbedingungen &amp; Datenschutzrichtlinie</strong></h1>

            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Gültig ab: 28. Juli 2025</p>

            <h2><strong>1. Überblick</strong></h2>
            <p>Diese Nutzungsbedingungen und Datenschutzrichtlinie („Richtlinie“) regelt die Kommunikation, die über Shift Arcade Ventures LLC („Shift Arcade Ventures“, „wir“, „unser“ oder „uns“) initiiert wird, einschließlich SMS, E-Mail und anderer elektronischer Nachrichten, die im Zusammenhang mit gesendet werden:</p>
            <ul>
                <li>Allgemeine Shift Arcade-Kommunikation</li>
                <li>Franchise-Anfragen und franchisebezogene Updates</li>
                <li>Kundenengagement auf Vor-Ort- oder Netzwerkebene</li>
            </ul>
            <p>
                Shift Arcade Ventures LLC ist der Franchisegeber und Markeninhaber von Shift Arcade. Einzelne Shift Arcade-Standorte sind unabhängige und eigenständige Unternehmen. Jeder Standort hat seine eigenen Nutzungsbedingungen und Datenschutzrichtlinien, die Reservierungen, Vor-Ort-Erfahrungen, Zahlungen,
                Verzichtserklärungen und standortspezifische Kommunikation regeln.
            </p>
            <p>Standortspezifische Bedingungen finden Sie auf den jeweiligen Standort-Websites (zum Beispiel:</p>
            <p>
                <a href="https://sanramon.shiftarcade.com/privacy-terms"> https://sanramon.shiftarcade.com/privacy-terms </a>
            </p>

            <h2><strong>2. Geltungsbereich dieser Richtlinie</strong></h2>
            <p>Diese Richtlinie gilt, wenn eine Person:</p>
            <ul>
                <li>Ein Formular auf einer Shift Arcade- oder Shift Arcade Ventures-Website einreicht</li>
                <li>Sich für den Erhalt von SMS- oder E-Mail-Kommunikation entscheidet</li>
                <li>Informationen über Shift Arcade-Standorte oder Franchise-Möglichkeiten anfordert</li>
                <li>Sich für Updates anmeldet, bevor ein bestimmter Standort ausgewählt wird</li>
            </ul>
            <p>Sobald ein Kunde direkt mit einem bestimmten Shift Arcade-Standort interagiert (zum Beispiel durch eine Reservierung), gelten die eigenen Nutzungsbedingungen und Datenschutzrichtlinien dieses Standorts für die Beziehung zu diesen Dienstleistungen.</p>

            <h2><strong>3. Kommunikations- &amp; Messaging-Programme</strong></h2>

            <h3><strong>3.1 Zweck der Kommunikation</strong></h3>
            <p>Durch die Anmeldung können Einzelpersonen Informations- und dienstleistungsbezogene Nachrichten erhalten, einschließlich, aber nicht beschränkt auf:</p>
            <ul>
                <li>Antworten auf Anfragen</li>
                <li>Updates im Zusammenhang mit Shift Arcade oder dem Shift Arcade-Netzwerk</li>
                <li>Nachverfolgung von Franchise-Anfragen (für potenzielle Franchisenehmer)</li>
                <li>Allgemeines Kundenengagement oder Informationsupdates</li>
            </ul>

            <p><strong>Wichtiger Unterschied (zur Klarstellung, nicht zur Trennung):</strong></p>
            <ul>
                <li>Franchise-Anfragen erhalten nur Kommunikation im Zusammenhang mit dem Franchise-Entdeckungsprozess.</li>
                <li>Kundenbezogene Kommunikation ist auf allgemeines, nicht standortspezifisches Engagement beschränkt, es sei denn und bis der Kunde mit einem bestimmten Standort interagiert.</li>
            </ul>
            <p>Daten, die für Franchise-Anfragen gesammelt werden, werden ausschließlich von Shift Arcade Ventures LLC verwaltet und nicht mit einzelnen Franchise-Standorten geteilt.</p>

            <h3><strong>3.2 SMS-Zustimmung &amp; Abmeldung</strong></h3>
            <p>Durch die Anmeldung für SMS-Kommunikation stimmen Sie zu, Textnachrichten von Shift Arcade Ventures LLC zu erhalten.</p>
            <ul>
                <li>Die Nachrichtenfrequenz variiert je nach Engagement</li>
                <li>Nachrichten- und Datengebühren können anfallen</li>
                <li>Netzbetreiber haften nicht für verspätete oder nicht zugestellte Nachrichten</li>
            </ul>
            <p>Sie können SMS-Nachrichten jederzeit abbestellen, indem Sie mit <strong>STOP</strong> antworten.</p>
            <p>Sie können Hilfe anfordern, indem Sie mit <strong>HILFE</strong> antworten.</p>
            <p>Nach der Abmeldung erhalten Sie eine Bestätigungsnachricht und es werden keine weiteren Nachrichten gesendet, es sei denn, Sie melden sich erneut an.</p>

            <h2><strong>4. Informationen, die wir sammeln</strong></h2>
            <p>Wir können die folgenden Informationen sammeln, wenn Sie mit uns interagieren:</p>
            <ul>
                <li>Name</li>
                <li>Telefonnummer</li>
                <li>E-Mail-Adresse</li>
                <li>Informationen, die freiwillig über Formulare oder Nachrichten bereitgestellt werden</li>
            </ul>
            <p>Diese Informationen werden nur für legitime Geschäftszwecke im Zusammenhang mit Kommunikation, Anfragebearbeitung und Kunden- oder Franchise-Engagement gesammelt.</p>

            <h2><strong>5. Wie wir Informationen verwenden</strong></h2>
            <p>Gesammelte Informationen können verwendet werden, um:</p>
            <ul>
                <li>Auf Anfragen zu antworten</li>
                <li>Angeforderte Informationen bereitzustellen</li>
                <li>Updates im Zusammenhang mit Ihrem geäußerten Interesse zu kommunizieren</li>
                <li>Kommunikations- und Supportprozesse zu verbessern</li>
                <li>Die Einhaltung gesetzlicher und messagingbezogener Anforderungen zu gewährleisten</li>
            </ul>
            <p>Wir verwenden diese Informationen <strong>nicht</strong> für nicht verwandte Marketingzwecke ohne entsprechende Zustimmung.</p>

            <h2><strong>6. Datenaustausch &amp; Dritte</strong></h2>
            <p>Wir verkaufen oder vermieten keine persönlichen Informationen.</p>
            <p>Wir können vertrauenswürdige Dienstleister (wie CRM-, E-Mail- oder SMS-Plattformen) ausschließlich zur Unterstützung von Kommunikation und Betrieb einsetzen. Diese Anbieter sind vertraglich verpflichtet, Daten zu schützen und die geltenden Datenschutzgesetze einzuhalten.</p>
            <p><strong>Opt-in-Daten und Zustimmung für Textnachrichten werden niemals geteilt</strong>, außer mit Aggregatoren und Anbietern, die zur Bereitstellung von Messaging-Diensten erforderlich sind.</p>

            <h2><strong>7. Datensicherheit</strong></h2>
            <p>Wir ergreifen angemessene administrative, technische und physische Maßnahmen, um persönliche Informationen zu schützen. Obwohl kein System garantiert 100% sicher ist, verwenden wir wirtschaftlich angemessene Schutzmaßnahmen, um Daten vor unbefugtem Zugriff oder Missbrauch zu schützen.</p>

            <h2><strong>8. Einhaltung von Gesetzen</strong></h2>
            <p>Wir halten die geltenden lokalen, staatlichen und bundesstaatlichen Gesetze ein, einschließlich mobiler Messaging-Vorschriften und Industriestandards (einschließlich TCPA- und CTIA-Richtlinien).</p>
            <p>Durch die Teilnahme an unserer Kommunikation erkennen Sie an und stimmen zu, alle geltenden Gesetze einzuhalten.</p>

            <h2><strong>9. Änderungen dieser Richtlinie</strong></h2>
            <p>Wir können diese Richtlinie von Zeit zu Zeit aktualisieren. Updates werden veröffentlicht unter:</p>
            <p>
                <strong>
                    <a href="https://shiftarcade.com/privacy-terms"> https://shiftarcade.com/privacy-terms </a>
                </strong>
            </p>
            <p>Die fortgesetzte Teilnahme an der Kommunikation nach Updates gilt als Annahme der überarbeiteten Richtlinie.</p>

            <h2><strong>10. Kontaktinformationen</strong></h2>
            <p>Für Fragen zu dieser Richtlinie oder unseren Datenpraktiken kontaktieren Sie bitte:</p>
            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>E-Mail: <strong>franchise@shiftarcade.com</strong></p>
        </div>
        <hr />
        <h2><strong>Apex Club Abonnementbedingungen</strong></h2>

        <h3><strong>Abonnementabrechnung &amp; Mindestlaufzeit</strong></h3>
        <p>Der Apex Club ist ein <strong>wiederkehrendes monatliches Abonnement</strong>. Durch die Anmeldung im Apex Club autorisiert der Kunde Shift Arcade, die ausgewählte Zahlungsmethode <strong>jeden Monat</strong> zum veröffentlichten Abonnementpreis automatisch zu belasten.</p>
        <p>
            Alle Apex Club-Abonnements haben eine
            <strong>Mindestlaufzeit von zwei (2) Monaten</strong>. Das Abonnement kann während der anfänglichen zweimonatigen Laufzeit nicht gekündigt werden.
        </p>
        <p>
            Nach Erfüllung der Mindestlaufzeit wird das Abonnement auf einer
            <strong>monatlichen Basis</strong> fortgesetzt, es sei denn, der Kunde kündigt.
        </p>

        <h3><strong>Verlängerung &amp; Kündigung</strong></h3>
        <p>Nach der anfänglichen zweimonatigen Mindestlaufzeit kann der Kunde das Abonnement jederzeit kündigen, indem er eine Mitteilung über sein Konto oder direkt beim Standort einreicht.</p>
        <p>Kündigungen werden zum <strong>Ende des aktuellen Abrechnungszeitraums</strong> wirksam. Es werden keine Teilrückerstattungen für ungenutzte Zeit, Guthaben oder Vorteile innerhalb eines Abrechnungszeitraums ausgestellt.</p>
        <p>Um die Apex Club-Mitgliedschaft zu kündigen, besuchen Sie Ihr Kontodashboard.</p>

        <h3><strong>Guthaben, Vorteile &amp; Nutzung</strong></h3>
        <p>Abonnementvorteile, einschließlich monatlicher Guthaben oder ermäßigtem Zugang, werden <strong>jeden Abrechnungszyklus</strong> ausgestellt und sind zur Nutzung während der aktiven Abonnementlaufzeit bestimmt.</p>
        <p>Ungenutzte Guthaben oder Vorteile:</p>
        <ul>
            <li>Werden nicht in Bargeld umgewandelt</li>
            <li>Sind nicht übertragbar</li>
            <li>Können verfallen, wenn das Abonnement gekündigt wird, abhängig von den spezifischen Bedingungen des Apex Club-Plans</li>
        </ul>
        <p>Abonnementvorteile unterliegen der Verfügbarkeit und können je nach Standort variieren.</p>

        <h3><strong>Keine Rückerstattungen für verpasste Nutzung</strong></h3>
        <p>
            Das Versäumnis, Apex Club-Vorteile während eines Abrechnungszeitraums zu nutzen, stellt keinen Grund für eine Rückerstattung oder Gutschrift dar. Das Abonnement bietet
            <strong>Zugang und Berechtigung</strong>, keine garantierte Nutzung.
        </p>

        <h3><strong>Änderungen der Abonnementbedingungen</strong></h3>
        <p>Shift Arcade behält sich das Recht vor, Apex Club-Preise, Vorteile oder Bedingungen mit angemessener Vorankündigung zu ändern. Änderungen gelten prospektiv und werden per E-Mail, SMS oder durch veröffentlichte Bedingungen mitgeteilt.</p>

        <h3><strong>Anerkennung</strong></h3>
        <p>Durch die Anmeldung im Apex Club erkennt der Kunde an und stimmt zu, dass:</p>
        <ul>
            <li>Das Abonnement <strong>monatlich</strong> abgerechnet wird</li>
            <li>Eine <strong>zweimonatige Mindestlaufzeit</strong> gilt</li>
            <li>Die Gebühren automatisch fortgesetzt werden, es sei denn, sie werden nach der Mindestlaufzeit gekündigt</li>
        </ul>
    </div>
</template>
